import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { salaryTypeById, updateSalaryType } from '../../../actions/utilitiesAction'
import Add from '../../../component/Utilities/Salary/AddSalary'
import constant from '../../../constant'
const AddSalary = () => {


    const [response, setResponse] = React.useState({})
    const [showMsg, setShowMsg] = React.useState(false)

    const navigate = useNavigate()
    const params = useParams()
    const [data, setData] = useState(null)
    useEffect(() => {
        salaryTypeById(params.id).then((res) => {
            if (res.status) {
                setData(res.result)
            }
            else {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)
            }
        }).catch(err => {
            alert(err)
        })
    }, [])

    const onSubmit = (model) => {
        updateSalaryType(model).then((res) => {
            if (res.status) {
                navigate(constant.component.salarylist.url)
            } else {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)
            }
        }).catch((err) => {
            alert(err)
        })
    }

    return (
        <React.Fragment>
            {data && <Add onSubmit={onSubmit} detail={data} response={response} showMsg={showMsg} />}
        </React.Fragment>
    )
}
export default AddSalary;